/**
 * Created by robert.lavoie on 6/21/17.
 */

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject ,  of } from 'rxjs';
import * as Raven from 'raven-js';

// Models
import { JobSearchParams, JobSearchQueryParams, SelectedJob } from '../models';
import { Owner } from 'careerpages-base/models/owner';


// Services
import { SiteService } from './site.service';

/**
 *
 * @class
 * JobsSearchService
 *
 * @description
 * This service is responsible for fetching jobs search data
 *
 */
@Injectable()
export class JobsSearchService {

  // Observable string sources
  private jobSelectedSource = new Subject<any>();

  // Observable string streams
  public jobSelected$ = this.jobSelectedSource.asObservable();

  constructor(private siteService: SiteService, private http: HttpClient) {}

  /**
   *
   * @param { selectedJob: selectedJob }
   */
  public selectJob(selectedJob: SelectedJob) {
    this.jobSelectedSource.next(selectedJob);
  }

  /**
   * Send Post request to the job seeker api
   * http://jsk.api.snagqa.corp:8310/#!/jobs/jobs_search_Resource
   *
   * @param { Object: JobSearchParams }
   * @param { Object: JobSearchQueryParams }
   * @return { Observable }
   */
  public getJobs(jobSearchParams: JobSearchParams, jobSearchQueryParams: JobSearchQueryParams): Observable<any> {
    const options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    };

    const data = {
      ...jobSearchParams,
      category: jobSearchQueryParams.jobTypes,
      jobTitle: jobSearchQueryParams.jobTitles,
      includefacetlist: true,
      manyselectfacets: ['category', 'jobtitle'],
      specificfacets: ['category', 'jobtitle'],
      facetsortdirection: 'asc',
      distancegrouping: 0,
      facetsort: 'name',
      facetlimit: 100,
      disablesuppression: true,
      specificlocationsonly: true
    };

    return this.http.post(`${this.siteService.getApiUrl()}/jobs/search`,  data, options);
  }


  /**
   * Handles the job search api errors
   *
   * @param { any }
   * @return { Observable }
   */
  private handleError(error: any): Observable<any> {
    Raven.captureException(error);
    return of(error);
  }

}